/**
 * Unified AI provider for CineVault.
 * Uses the server-side OpenRouter proxy so provider credentials never enter
 * the browser bundle.
 */

interface GenerateTextOptions {
  temperature?: number;
  maxTokens?: number;
  useProModel?: boolean;
}

interface AIProxyResponse {
  text?: string;
  model?: string;
  usage?: {
    total_tokens?: number;
  };
}

export function getAIProviderLabel(): string {
  return 'OpenRouter proxy';
}

export function isAIConfigured(): boolean {
  // Vite's local server does not mount Vercel Functions. Production requests
  // stay same-origin and let /api/ai decide whether its server secret exists.
  return import.meta.env.PROD;
}

export async function generateAIText(
  prompt: string,
  options: GenerateTextOptions = {}
): Promise<string> {
  const temperature = options.temperature ?? 0.7;
  const maxTokens = options.maxTokens ?? 2048;

  try {
    const response = await fetch('/api/ai', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        prompt,
        temperature,
        maxTokens,
      }),
    });

    if (!response.ok) {
      throw new Error(`AI proxy error: ${response.status}`);
    }

    const data: AIProxyResponse = await response.json();
    const result = data.text || '';
    console.log(`AI: ${data.model || 'OpenRouter'} via server proxy - ${data.usage?.total_tokens || 0} tokens`);
    return result;
  } catch (error) {
    console.warn('AI proxy unavailable; using CineVault fallback data.', error);
    return '';
  }
}
